// src/App.js
import React, { useState, useEffect, useRef } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginForm from './components/auth/LoginForm';
import Homepage from './components/home/Homepage';
import BottomNav from './components/navigation/BottomNav';
import AchievementsPage from './components/achievements/AchievementsPage';
import ProfilePage from './components/profile/ProfilePage';
import ProgressPage from './components/progress/ProgressPage';
import LibraryPage from './components/library/LibraryPage';
import AdminShell from './components/admin/AdminShell';
import DemoHomepage from './components/demo/DemoHomepage';
import './App.css';

function AppContent() {
  const { currentUser, userData, loading } = useAuth();
  const [activeTab, setActiveTab] = useState('home');
  const [achievementDotTrigger, setAchievementDotTrigger] = useState(0);
  const [hideBottomNav, setHideBottomNav] = useState(false);
  const prevUserRef = useRef(null);

  useEffect(() => {
    if (currentUser?.uid !== prevUserRef.current) {
      prevUserRef.current = currentUser?.uid;
      setActiveTab('home');
    }
  }, [currentUser]);

  useEffect(() => {
    if (activeTab === 'achievements' && currentUser?.uid) {
      const key = `newAchievements_${currentUser.uid}`;
      localStorage.removeItem(key);
      setAchievementDotTrigger(v => v + 1);
    }
  }, [activeTab, currentUser]);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>लोड होत आहे...</p>
      </div>
    );
  }

  if (!currentUser) return <LoginForm />;

  if (currentUser?.email === '1234512345@spocademy.com') return <DemoHomepage />;

  if (userData?.role === 'admin') return <AdminShell />;

  const hasNewAchievement = (() => {
    if (!currentUser?.uid) return false;
    const key = `newAchievements_${currentUser.uid}`;
    const pending = JSON.parse(localStorage.getItem(key) || '[]');
    return pending.length > 0;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  })();

  const missingPhoto = !userData?.photoURL;

  const renderTab = () => {
    switch (activeTab) {
      case 'home': return <Homepage activeTab={activeTab} setActiveTab={setActiveTab} setHideBottomNav={setHideBottomNav} />;
      case 'progress': return <ProgressPage />;
      case 'achievements': return <AchievementsPage />;
      case 'library': return <LibraryPage setHideBottomNav={setHideBottomNav} />;
      case 'profile': return <ProfilePage />;
      default: return <Homepage activeTab={activeTab} setActiveTab={setActiveTab} setHideBottomNav={setHideBottomNav} />;
    }
  };

  return (
    <div className="app-wrapper">
      {renderTab()}
      {!hideBottomNav && (
        <BottomNav
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          hasNewAchievement={hasNewAchievement}
          missingPhoto={missingPhoto}
          key={achievementDotTrigger}
        />
      )}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;